export default __webpack_public_path__ + "static/media/PEGI_15.58924f08.svg";